import { GridApi, IGetRowsParams } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { TaxAccessSyncLogRepository } from '../taxAccessSyncLog.repository';

export class TaxAccessSyncLogDetailsAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _taxAccessSyncLogRepository: TaxAccessSyncLogRepository,
        private readonly _summaryLogId: number,
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.TaxAccessSyncDetailLogPropertyEnum>[] = [
        { name: 'taxAccessSyncDetailLogId', value: Core.TaxAccessSyncDetailLogPropertyEnum.TaxAccessSyncDetailLogId },
        { name: 'batchId', value: Core.TaxAccessSyncDetailLogPropertyEnum.BatchId },
        { name: 'appealId', value: Core.TaxAccessSyncDetailLogPropertyEnum.AppealId },
        { name: 'status', value: Core.TaxAccessSyncDetailLogPropertyEnum.Status },
        { name: 'logTimeUtc', value: Core.TaxAccessSyncDetailLogPropertyEnum.LogTimeUtc },
        { name: 'message', value: Core.TaxAccessSyncDetailLogPropertyEnum.Message },
    ];

    protected canGetRows(): boolean {
        return !!this._summaryLogId;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.TaxAccessSyncDiagnosticsDetailSearchModel = {
            summaryLogId: this._summaryLogId,
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow,
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap),
        };

        const result = await lastValueFrom(this._taxAccessSyncLogRepository.getDetail(searchParams));

        return {
            rows: result.detailLogs,
            totalRows: result.detailLogTotalRows,
        } as AgGridDataSourceResult;
    }
}
